// Lucide icon: car (https://lucide.dev/icons/car)
import { Car } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMileage = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Car />
    </IconComponentStyled>
  )
}
